var exports = {
  "my": "avatar__1wK7ad",
  "V8": "sponsorButton__Lf8Rl8",
  "AX": "resultRow__e_cHI2",
  "Cd": "leftColumn__kKiobN",
  "R3": "avatarWrapper__z4AUEk",
  "qy": "contentColumn__-wrhlk",
  "Dq": "footerIcon__diBhTf",
  "DK": "rightColumn___FKhze",
  "ud": "titleName__utQro5",
  "eb": "titleLogin__us_Pw1",
  "Ip": "titleLoginSpaced__gAj2QK",
  "v7": "titleLoginText__Yy6ETa",
};

module.exports = exports;
